import { RespostaCanalDireto } from "../../types/atendimentos/channel-direct/types";
import { HistoricoAtendimento } from "../../types/atendimentos/historico/types";
import { AttachExtranetFilesParams, AttachIntranetFilesParams, TicketCreatedResponse, TicketSupportForm } from "../../types/atendimentos/pre-atendimento/types";
import { api } from "../api"

export const fetchHistoricoAtendimentos = async (numFicha: number, situacaoFicha: string): Promise<HistoricoAtendimento[]> => {
    const url = `/atendimentos/historicoatendimento`;

    const { data } = await api.get<HistoricoAtendimento[]>(url, {
        params: {
            numFicha,
            situacaoFicha,
        },
    });

    return data;
};

export const cadastrarAtendimento = async (form: TicketSupportForm): Promise<TicketCreatedResponse> => {
    const url = `/atendimentos/cadastraratendimento`;

    const { data } = await api.post<TicketCreatedResponse>(url, {
        ...form
    });

    return data;
};


export const anexarArquivoAtendimento = async (params: AttachExtranetFilesParams) => {
    const url = `/atendimentos/anexararquivoextranet`;

    const { data } = await api.post(url, {
        ...params
    });

    return data;
};


export const anexarArquivoIntranet = async (params: AttachIntranetFilesParams) => {
    const url = `/atendimentos/anexararquivointranet`;

    const { data } = await api.post(url, {
        ...params
    });

    return data;
};


export const fetchRespostaCanalDireto = async (numeroFicha: number): Promise<RespostaCanalDireto> => {
    const url = `/atendimentos/buscarrespostacanaldireto`;

    const { data } = await api.get<RespostaCanalDireto>(url, {
        params: {
            numeroFicha,
        },
    });

    return data;
};
